var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slide',{attrs:{"anchor":"portfolio","title":"Портфолио","linkable":""}},_vm._l((_vm.portfolio),function(project,name){return _c('PortfolioProject',{key:name,attrs:{"project":project,"name":name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }